var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [_vm._v(_vm._s(_vm.f.Name))]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.f.Value,
          expression: "f.Value",
          modifiers: { number: true },
        },
      ],
      staticClass: "form-control",
      attrs: { type: "number", readonly: "" },
      domProps: { value: _vm.f.Value },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.f, "Value", _vm._n($event.target.value))
        },
        blur: function ($event) {
          return _vm.$forceUpdate()
        },
      },
    }),
    _vm._v(" "),
    _vm.f.Description
      ? _c("small", { staticClass: "form-text text-muted" }, [
          _vm._v(_vm._s(_vm.f.Description)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }